package com.essntl.features.proposal.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import core.dateformat.utils.parseLocalDateOrNull
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.price.domain.model.proposalserviceprice.ProposalServicePriceModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.proposal.ui.proposalhistory.components.JourneyRowUiState
import com.essntl.features.request.domain.model.RequestModel
import core.dateformat.ui.formatDateRange
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus

@Composable
fun rememberPriceIntSum(
    proposalServiceList: List<ProposalServiceModel>,
    priceList: List<ProposalServicePriceModel>,
): Int {
    // TODO: for dynamic prices select those with visibility = ONLY_OPTION or selected = TRUE
    return remember(proposalServiceList, priceList) {
        proposalServiceList.sumOf { it.price ?: 0 }// + priceList.sumOf { it.total?.toInt() ?: 0 }
    }
}

@Composable
fun rememberCommissionIntSum(
    proposalServiceList: List<ProposalServiceModel>,
    proposal: ProposalModel,
): Int {
    val commission = proposal.commission?.toInt() ?: 0
    return remember(proposalServiceList, proposal) {
        proposalServiceList.filter { it.commissionable == true }.sumOf { (it.price ?: 0) * commission / 100 }
    }
}

@Composable
fun rememberLocalDate(
    index: Int,
    fromDate: String?,
): LocalDate? {
    return remember(index, fromDate) {
        parseLocalDateOrNull(fromDate)?.plus(DatePeriod(days = index))
    }
}

@Composable
fun rememberDayProposalServiceList(
    localDate: LocalDate?,
    proposalServiceList: List<ProposalServiceModel>,
): List<ProposalServiceModel> {
    return remember(localDate, proposalServiceList) {
        proposalServiceList
            .filter { it.startDate == localDate.toString() }
            .sortedBy { it.index }
    }
}

@Composable
fun rememberDayRowUiStateList(
    localDate: LocalDate?,
    journeyRowList: List<JourneyRowUiState>,
): List<JourneyRowUiState> =
    remember(localDate, journeyRowList) {
        journeyRowList
            .filter { it.startDate == localDate.toString() }
            .sortedBy { it.index }
    }


@Composable
fun rememberFilteredRequests(
    requests: List<RequestModel>,
    searchText: String,
): List<RequestModel> {
    return remember(
        requests,
        searchText,
    ) {
        requests
            .filter {
                it.title?.contains(searchText.trim(), ignoreCase = true) ?: false
            }
            .sortedWith(
                compareByDescending { it.createdAt },
            )
    }
}